export const LANG_ACTION = 'LANG_ACTION';
